import { useKFlags } from '@/hooks/use-k-flags';
import {
  Box,
  Table as CTable,
  Tbody,
  Thead,
  Th,
  Td,
  Tr,
} from '@chakra-ui/react';
import { useHover } from '../hooks/useHover';
import { TableSort } from '../sort';
import './index.css';

const Header = ({ column }) => {
  const { customSort: sort, customSortKey: key = column.id } = column;
  const { hoverProps, hover } = useHover();
  return (
    <Th
      {...column.getHeaderProps()}
      {...(sort ? hoverProps : {})}
      display="flex"
      alignItems="center"
      onClick={() => {
        if (sort?.key !== key || sort?.direction === 'default') {
          sort?.setSort?.({ key, direction: 'desc' });
        } else if (sort?.direction === 'desc') {
          sort?.setSort?.({ key, direction: 'asc' });
        } else {
          sort?.setSort?.({ key, direction: 'default' });
        }
      }}
    >
      {column.render('Header')}
      {sort && (hover || (sort?.key === key && sort?.direction !== 'default')) ? (
        <TableSort
          direction={sort?.key === key ? sort?.direction : 'default'}
          marginLeft="auto"
        />
      ) : null}
    </Th>
  );
};

export default function Table({
  table = {},
  isReadOnly = false,
  isFullScreen,
}) {
  const { getTableProps, getTableBodyProps, headerGroups, prepareRow, rows } =
    table;
  const { ats_enabled } = useKFlags();
  return (
    <Box
      className="data-table"
      maxH="100%" //ats_enabled && !isReadOnly && !isFullScreen ? '100%' : '100%'}
      minH={ats_enabled ? '180px' : undefined}
      overflow={ats_enabled ? 'scroll' : 'auto'}
    >
      <CTable {...getTableProps()}>
        <Thead>
          {headerGroups.map((headerGroup) => (
            <Tr {...headerGroup.getHeaderGroupProps()} background="#fff">
              {headerGroup.headers.map((column, inx) => (
                <Header column={column} key={`react-table-header-${inx}`} />
              ))}
            </Tr>
          ))}
        </Thead>
        <Tbody {...getTableBodyProps()}>
          {rows.map((row) => {
            prepareRow(row);
            return (
              <Tr {...row.getRowProps()}>
                {row.cells.map((cell) => {
                  return (
                    <Td {...cell.getCellProps()}>{cell.render('Cell')}</Td>
                  );
                })}
              </Tr>
            );
          })}
        </Tbody>
      </CTable>
    </Box>
  );
}
